// removed by extract-text-webpack-plugin
module.exports = {"typingIndicatorWrapper":"_1x4sFzk50HGqBFxx4FaJQO","circleGWrapper":"_3LGqvYQr51WQIddo0JDiTu","circleG":"wb80zmzdc16cmrBataslV","bounce_circleG":"_2Ni1-9cNSo4WdSK9pOsRzT","circleG_1":"qo1ZZ8vqDdnT7uESAcRWh","circleG_2":"_2sVc1JGhUL7fEl3Mnzvl7v","circleG_3":"_1pbZ2e-7EseGqGRfXHJdHM"};


//////////////////
// WEBPACK FOOTER
// ./src/component/TypingIndicator/Bubble/style.css
// module id = 1550
// module chunks = 0